import { ApiError } from '@familywallet/api-client';
import { useTranslation } from 'react-i18next';

/** Maps an API error's stable code to a translated sentence. */
export function useErrorMessage() {
  const { t, i18n } = useTranslation();
  return (error: unknown): string => {
    if (error instanceof ApiError) {
      const key = `errors.${error.code}`;
      return i18n.exists(key) ? t(key) : t('errors.generic');
    }
    if (error instanceof TypeError) return t('errors.network');
    return t('errors.generic');
  };
}

export function FormError({ error }: { error: unknown }) {
  const message = useErrorMessage();
  if (!error) return null;
  return (
    <p role="alert" className="rounded-xl border border-danger bg-surface p-3 text-sm text-danger">
      {message(error)}
    </p>
  );
}
